import React from 'react';
import DashboardLayout from '../../components/layouts/dashboardLayout'

function Billings() {
   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">


            <div className='row my-3'>
                  <div className='col-12'>
                     <div className="card p-3 dashboard-card">
                        <div className="card-heading text-muted">Billing list</div>
                        <div className="alert alert-info">
                           Please pay your bill on ***************** bank account number and after that upload that picture to billing picture.
                        </div>
                        <div className="table-responsive">
                        <table className='table '>
                              <thead>
                                 <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Note</th>
                                    <th>Billing Time</th>
                                    <th>Status</th>
                                    <th>Due Date</th>
                                    <th>Last Date</th>
                                    <th>Amount</th>
                                    <th>Paid picture</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr>
                                    <td>1</td>
                                    <td>Description</td>
                                    <td>Any special note to user</td>
                                    <td className='text-center'>01/07/2021 <br /> to<br /> 01/08/2021</td>
                                    <td>UnPaid</td>
                                    <td>01/07/2021</td>
                                    <td>10/07/2021</td>
                                    <td>Rs 2000</td>
                                    <td><button className='btn btn-primary btn-sm'>Upload Picture</button></td>
                                 </tr>
                                 <tr>
                                    <td>1</td>
                                    <td>Description</td>
                                    <td>Any special note to user</td>
                                    <td className='text-center'>01/07/2021 <br /> to<br /> 01/08/2021</td>
                                    <td>UnPaid</td>
                                    <td>01/07/2021</td>
                                    <td>10/07/2021</td>
                                    <td>Rs 2000</td>
                                    <td><button className='btn btn-primary btn-sm'>Upload Picture</button></td>
                                 </tr>
                                 <tr>
                                    <td>1</td>
                                    <td>Description</td>
                                    <td>Any special note to user</td>
                                    <td className='text-center'>01/07/2021 <br /> to<br /> 01/08/2021</td>
                                    <td>UnPaid</td>
                                    <td>01/07/2021</td>
                                    <td>10/07/2021</td>
                                    <td>Rs 2000</td>
                                    <td><button className='btn btn-primary btn-sm'>Upload Picture</button></td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>

                  </div>
               </div>



            
            </div>
         </DashboardLayout>

      </>
   )
}

export default Billings